import Vue from 'vue'
import Vuex from 'vuex'

import collections, { CollectionsState } from './modules/collections'
import products, { ProductsState } from './modules/products'
import checkout, { CheckoutState } from './modules/checkout'
import redemption, { RedemptionState } from './modules/redemption'
import shopify, { ShopifyState } from './modules/shopify'
import navigation, { NavigationState } from './modules/navigation'
import auth, { IAuthState } from './modules/auth'
import alert, { AlertState } from './modules/alert'
import ticket, { TicketState } from './modules/ticket'
import booking, { IBookingState } from './modules/booking'
import notification, { NotificationState } from './modules/notification'
import rating, { RatingState } from './modules/rating'
import facility, { FacilityState } from './modules/facility'
import cart, { CartState } from './modules/cart'

// import 'babel-polyfill'
import VuexPersistence from 'vuex-persist'
import { fetchDomAttribute } from '@/utils/util.dom'

const { hash } = window.location
const newHash = hash.split('?')[0]
const merchantId = newHash.split('/')[3] || fetchDomAttribute('key')

const VuexLocal = new VuexPersistence<RootState>({
  key: `vc_ticket_${merchantId}`,
  storage: window.localStorage,
  reducer: (state) => ({
    auth: {
      id: state.auth.id,
      chatbotCustomer: state.auth.chatbotCustomer,
      merchant: state.auth.merchant,
      phone_number: state.auth.phone_number,
      birthDate: state.auth.birthDate,
      nationality: state.auth.nationality,
      address: state.auth.address,
      email: state.auth.email,
      number: state.auth.number,
      otpToken: state.auth.otpToken,
      otpType: state.auth.otpType,
      setupComplete: state.auth.setupComplete,
      token: state.auth.token,
      firstName: state.auth.firstName,
      lastName: state.auth.lastName,
      isVerifiedBySingpass: state.auth.isVerifiedBySingpass,
      userSingpass: state.auth.userSingpass,
      giftInfo: state.auth.giftInfo,
      giftRedeem: state.auth.giftRedeem,
      agreedToTerms: state.auth.agreedToTerms,
      agreedToPromotions: state.auth.agreedToPromotions,
      isGuestLogin: state.auth.isGuestLogin,
    },
    cart: {
      cart: state.cart.cart
    }
  }),
})

Vue.use(Vuex)

export interface RootState {
  collections: CollectionsState;
  products: ProductsState;
  checkout: CheckoutState;
  redemption: RedemptionState;
  auth: IAuthState;
  shopify: ShopifyState;
  navigation: NavigationState;
  alert: AlertState;
  ticket: TicketState;
  booking: IBookingState;
  notification: NotificationState;
  rating: RatingState;
  facility: FacilityState;
  cart: CartState;
}

export default new Vuex.Store<RootState>({
  modules: {
    collections,
    products,
    checkout,
    redemption,
    auth,
    shopify,
    navigation,
    alert,
    ticket,
    booking,
    notification,
    rating,
    facility,
    cart,
  },
  plugins: [VuexLocal.plugin],
})
